import * as server from '../entries/pages/admin/category/_id_integer_/_page.server.ts.js';

export const index = 23;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/admin/category/_id_integer_/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/admin/category/[id=integer]/+page.server.ts";
export const imports = ["_app/immutable/nodes/23.Cmq-BmyK.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/CnGaPG_y.js","_app/immutable/chunks/DIeogL5L.js","_app/immutable/chunks/BBilxCvN.js","_app/immutable/chunks/7JdHMB9Z.js","_app/immutable/chunks/BqhvobEz.js","_app/immutable/chunks/CSCnOrkp.js","_app/immutable/chunks/Dvhcax_L.js","_app/immutable/chunks/Dsy9VFq4.js","_app/immutable/chunks/CAN0e4T3.js","_app/immutable/chunks/Bu9wkQ5s.js","_app/immutable/chunks/DGA84RoI.js"];
export const stylesheets = [];
export const fonts = [];
